(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[523],{

/***/ 82415:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/[handle]",
      function () {
        return __webpack_require__(43013);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 43013:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ Blog; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(31373);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ./src/templates/blog/BlogNav/BlogNav.jsx + 4 modules
var BlogNav = __webpack_require__(47207);
;// CONCATENATED MODULE: ./src/templates/blog/blog.jsx




function BlogTemplate(param) {
    var renderSections = param.renderSections;
    var blog = (0,dist.useBlog)();
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        "data-comp": "BlogTemplate",
        children: [
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(BlogNav/* BlogNav */.a, {
                blogHandle: blog === null || blog === void 0 ? void 0 : blog.handle,
                articlePage: false
            }),
            renderSections()
        ]
    });
}

;// CONCATENATED MODULE: ./src/templates/blog/index.js

/* harmony default export */ var templates_blog = (BlogTemplate);

// EXTERNAL MODULE: ./src/_components/index.js + 9 modules
var _components = __webpack_require__(93183);
;// CONCATENATED MODULE: ./src/pages/blogs/[handle]/index.jsx
/* eslint-disable import/no-unresolved */ 







var __N_SSG = true;
function Blog(_param) {
    var isPreview = _param.isPreview, renderSections = _param.renderSections, props = (0,_object_without_properties/* default */.Z)(_param, [
        "isPreview",
        "renderSections"
    ]);
    var blog = props.blog;
    var setBlog = dist.store.recoil.useRecoilState(dist.store.state.blog)[1];
    (0,react.useEffect)(function() {
        setBlog(blog);
    }, [
        blog === null || blog === void 0 ? void 0 : blog.handle
    ]);
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(_components/* PageErrorBoundary */.bg, {
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(_components/* PageHead */.yG, {
            page: blog,
            children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(templates_blog, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                renderSections: renderSections
            }))
        })
    });
}


/***/ }),

/***/ 47207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "a": function() { return /* binding */ BlogNav; }
});

// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(85034);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(70169);
// EXTERNAL MODULE: ../node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(3204);
// EXTERNAL MODULE: ../node_modules/theme-ui/jsx-runtime/dist/theme-ui-jsx-runtime.esm.js + 2 modules
var theme_ui_jsx_runtime_esm = __webpack_require__(70863);
// EXTERNAL MODULE: ../node_modules/react/index.js
var react = __webpack_require__(27378);
// EXTERNAL MODULE: ../node_modules/@theme-ui/components/dist/theme-ui-components.esm.js
var theme_ui_components_esm = __webpack_require__(62680);
// EXTERNAL MODULE: ../node_modules/@backpackjs/storefront/dist/index.js
var dist = __webpack_require__(52031);
// EXTERNAL MODULE: ./src/utils/index.js + 7 modules
var utils = __webpack_require__(39136);
// EXTERNAL MODULE: ./src/snippets/index.js + 362 modules
var snippets = __webpack_require__(61653);
// EXTERNAL MODULE: ./src/theme/create.jsx
var create = __webpack_require__(73355);
;// CONCATENATED MODULE: ./src/templates/blog/BlogNav/Header/Header.theme.js

var themed = (0,create/* create */.U)(new function() {
    this.header = {
        display: "flex",
        width: [
            "fit-content",
            "100%"
        ],
        flexDirection: "column"
    };
    this.heading = {
        variant: "text.h1",
        flex: 1,
        mx: [
            10,
            8
        ]
    };
}());

;// CONCATENATED MODULE: ./src/templates/blog/BlogNav/Header/Header.jsx







var Header = themed(function(param) {
    var theme = param.theme, text = param.text;
    var headingText = (text === null || text === void 0 ? void 0 : text.heading) || "# Blog";
    var justifyContentArr = [
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignment),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignment),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignmentDt),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignmentDt), 
    ];
    var alignItemsArr = [
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignment),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignment),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignmentDt),
        (0,utils/* convertAlignToFlex */.nG)(text === null || text === void 0 ? void 0 : text.alignmentDt), 
    ];
    var textAlignArr = [
        text === null || text === void 0 ? void 0 : text.alignment,
        text === null || text === void 0 ? void 0 : text.alignment,
        text === null || text === void 0 ? void 0 : text.alignmentDt,
        text === null || text === void 0 ? void 0 : text.alignmentDt, 
    ];
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
        "data-comp": Header.displayName,
        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.header), {
            justifyContent: justifyContentArr,
            alignItems: alignItemsArr
        }),
        children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(snippets/* Markdown */.UG, {
            textSx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.heading), {
                textAlign: textAlignArr
            }),
            children: headingText
        })
    });
});
Header.displayName = "Header";

;// CONCATENATED MODULE: ./src/templates/blog/BlogNav/Header/index.js


;// CONCATENATED MODULE: ./src/templates/blog/BlogNav/BlogNav.theme.js

var BlogNav_theme_themed = (0,create/* create */.U)(new function() {
    this.wrapper = {
        display: "flex",
        flexDirection: "column",
        alignContent: "center",
        alignItems: "center",
        justifyContent: "center",
        overflow: "hidden",
        minHeight: 56,
        py: [
            6,
            8
        ],
        px: 8
    };
    this.header = {
        mb: [
            "12px",
            "16px"
        ]
    };
    this.scroll = {
        flexWrap: [
            "noWrap",
            "wrap"
        ],
        justifyContent: [
            "flex-start",
            "center"
        ],
        width: "100%",
        height: "100%",
        overflowY: "hidden",
        overflowX: "auto",
        whiteSpace: "nowrap",
        webkitOverflowScrolling: "touch",
        msOverflowStyle: "none",
        scrollbarWidth: "none",
        pb: 3,
        "::-webkit-scrollbar": {
            display: "auto"
        }
    };
    this.link = {
        mb: [
            0,
            3
        ],
        variant: "text.label.1",
        minWidth: "auto",
        height: 32,
        px: 11,
        bg: "gray",
        lineHeight: 32,
        whiteSpace: "nowrap",
        borderRadius: 16,
        cursor: "pointer",
        transition: "background-color 0.2s ease-in-out",
        ":hover": {
            bg: "mediumGray"
        }
    };
}());

;// CONCATENATED MODULE: ./src/templates/blog/BlogNav/BlogNav.jsx









var BlogNav = BlogNav_theme_themed(function(param) {
    var theme = param.theme, _articlePage = param.articlePage, articlePage = _articlePage === void 0 ? false : _articlePage;
    var settings = (0,dist.useSettings)();
    var text = ((settings === null || settings === void 0 ? void 0 : settings.blogSettings) || {}).text;
    var blog = (0,dist.useBlog)();
    var router = (0,dist.useRouter)();
    var categories = (0,react.useMemo)(function() {
        var ref;
        if (!(blog === null || blog === void 0 ? void 0 : (ref = blog.articles) === null || ref === void 0 ? void 0 : ref.length)) return [];
        var articleCategories = blog === null || blog === void 0 ? void 0 : blog.articles.map(function(value, index) {
            if (value.category !== "") return value.category;
        });
        return (0,_to_consumable_array/* default */.Z)(new Set((0,_to_consumable_array/* default */.Z)((articleCategories === null || articleCategories === void 0 ? void 0 : articleCategories.filter(function(category) {
            return category;
        })) || [])));
    }, [
        blog === null || blog === void 0 ? void 0 : blog.articles
    ]);
    var activeCategoryLink = (0,react.useMemo)(function() {
        if (!router.query.category) {
            return "All";
        }
        return categories === null || categories === void 0 ? void 0 : categories.find(function(category) {
            return category === router.query.category;
        });
    }, [
        router.query.category
    ]);
    var handleClick = (0,react.useCallback)(function(categorySelected) {
        var item = categories === null || categories === void 0 ? void 0 : categories.find(function(category) {
            return category === categorySelected;
        });
        var encoded = encodeURIComponent(item);
        var link = "articles/".concat(categorySelected === "All" ? "" : "?category=".concat(encoded));
        articlePage ? router.replace("/blogs/".concat(link)) : router.push(link, undefined, {
            shallow: true
        });
    });
    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsxs */.BX)(theme_ui_components_esm/* Container */.W2, {
        sx: theme.wrapper,
        children: [
            !articlePage && /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Box */.xu, {
                sx: theme.header,
                children: /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(Header, {
                    text: text
                })
            }),
            /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Flex */.kC, {
                sx: theme.scroll,
                children: categories && [
                    "All"
                ].concat((0,_to_consumable_array/* default */.Z)(categories)).map(function(category, index, arr) {
                    if (!category) return null;
                    var isActive = category === activeCategoryLink;
                    var rightMargin = index !== arr.length - 1 ? 3 : 0;
                    return /*#__PURE__*/ (0,theme_ui_jsx_runtime_esm/* jsx */.tZ)(theme_ui_components_esm/* Button */.zx, {
                        variant: "buttons.plain",
                        sx: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, theme.link), {
                            mr: rightMargin,
                            bg: isActive ? "mediumGray" : theme.link.bg
                        }),
                        onClick: function() {
                            return handleClick(category);
                        },
                        children: category
                    }, index);
                })
            })
        ]
    });
});
BlogNav.displayName = "BlogNav";


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [774,888,179], function() { return __webpack_exec__(82415); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);